import { getAxiosInstance } from "../../../../../api";

export const requestAdditionalDocument = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      "admin/remittance/documents/request-additional",
      body
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};
